import { api, formHeaders } from "@";

// Fetches the home page banner data from the API
export const getBanners = () => api.get("/api/AdminHomePageBanner");

// Saves the home page banner data to the API
export const saveBanner = (data) => {
  if (data.Id) {
    return api.put(`/api/AdminHomePageBanner/${data.Id}`, data, formHeaders);
  }
  return api.post("/api/AdminHomePageBanner", data, formHeaders);
};
